import { orderBy as lOrderBy } from "lodash";

export function orderBy<T>(items: T[], iteratees: Array<keyof T>, orders?: Array<"asc" | "desc">) {
    return lOrderBy(items, iteratees, orders);
}

export default orderBy;
